import {
	Component,
	ComponentFactoryResolver,
	OnDestroy,
	OnInit,
	ViewChild }
from "@angular/core";
import { GridBaseComponent, ModalButtonModel, ModalService, ModalSize, SubContentService } from "@cv-invision/core";
import { AceEditorComponent } from "ngx-ace-editor-wrapper";
import { Subject, takeUntil } from "rxjs";
// Service
import { PartialIntegrationService } from "../../services/data-loader-partial-integration.service";
// Model
import { PartialsOrderLogsColumnsModel } from "../../models/integrations";
import { ORIGIN, OriginSourceData, URLS } from "../../models/partial-integration.model";
// Other
import { ClipboardService } from "ngx-clipboard";
import { ActivatedRoute, Router } from "@angular/router";
import { CvDateFormatter } from "@cv-invision/cv.component-library.ux";
import { RequestInformationPartialComponent } from "../request-information-partial-log/request-information-partial-log.component";

@Component({
	selector: 'cv-invision-orders-partial-log',
	templateUrl: './orders-partial-log.component.html',
	styleUrls: ['./orders-partial-log.component.scss']
})
export class OrdersPartialLogComponent extends GridBaseComponent implements OnInit, OnDestroy {

	private atComponentDestroy: Subject<any> = new Subject<any>();
	@ViewChild('markupEditor', { static: false }) markupEditor: AceEditorComponent;
	responseData: any;
	appScopeMsgRequest: string;
	msgRequest: string;
	copyMsgRequest: Array<ModalButtonModel>;
	rowClassRules: any;
	origin: ORIGIN;
	id: string;

	constructor(
		private router: Router,
		private clipboarService: ClipboardService,
		private dataLoaderService: PartialIntegrationService,
		private route: ActivatedRoute,
		private dateService: CvDateFormatter,
		private subContentService: SubContentService,
		private componentFactoryResolver: ComponentFactoryResolver,
		private modalService: ModalService,
		private partialIntegrationService: PartialIntegrationService) {
		super();

		this.rowClassRules = {
			'error-row': function(params: any): boolean {
				return !params.data.valid;
			}
		};
	}

	ngOnInit(): void {
		switch (true) {
			case this.router.url.includes(URLS.RELIANCE_FIRST_DETAIL):
				this.origin = ORIGIN.RELIANCE_FIRST;
				break;
			case this.router.url.includes(URLS.MI_MUTUAL_DETAIL):
				this.origin = ORIGIN.MI_MUTUAL;
				break;
		}

		this.gridOptions.columnDefs = new PartialsOrderLogsColumnsModel(this.dateService).columns;
		this.loadGridData();

		this.partialIntegrationService
			.getReloadListListener()
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((data: OriginSourceData) => {
				if (data.origin === 'logs') {
					this.loadGridData();
				}
			});
	}

	/**
     * populate it with the detailed order data
     */
	loadGridData(): void {
		this.id = this.route.snapshot.params.id
		this.dataLoaderService.getOrderDetails(this.id, this.origin)
		.pipe(takeUntil(this.atComponentDestroy))
		.subscribe((data: any) => {
			this.gridData = data.data;
		});
	}

	/***
	 * copy response code
	 */
	onCopycode(source: string): void {
		this.clipboarService.copy(source);
	}

	/**
     * Open a modal to display request information
     * @param logsInputs The logs input data to display in the modal
     */
	openRequestInformationModal(logsInputs: any): void {
		this.modalService.open({
			componentFactoryResolver: this.componentFactoryResolver,
			component: RequestInformationPartialComponent,
			data: {
				request: { data: logsInputs }
			},
			modalConfiguration: {
				title: `Detail Message Request Order ${this.id}`,
				modalSize: ModalSize.XXL
			}
		}).pipe(
			takeUntil(this.atComponentDestroy)
		).subscribe(result => {
			if (result.status === 'accept' && result.definition) {
				// Handle accepted result
			}
		});
	}

	/**
	 * Selected order
	 */
	public onSelectionChanged(): void {
		const selectedRows = this.gridApi.getSelectedRows();
		const selectedRow = selectedRows[0];
		if (selectedRow && selectedRow.messageRequest != "") {
			const messageRequest = JSON?.parse(selectedRow.messageRequest);
			this.openRequestInformationModal(messageRequest);
		} else {
			this.subContentService.close();
		}
	}

	/**
	 * On component destroy
	 */
	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
